// Loaded HDF5 field state: metadata, component arrays, active selection.
// Mutated by app/fieldData + app/datasetManager.

import { DATASET_DEFAULTS } from '../../config/defaults';
import type { FieldMetadata } from '../../physics/types';

export interface FieldState {
    metadata: FieldMetadata | null;
    data: Record<string, Float32Array | undefined> | null;
    gridFlat: Float32Array | null;
    currentComponent: string;
    currentDataset: string;
    hdf5Url: string | null;
    modelName: string;
    dataTime: string | number | null;
    dataTimeUnits: string | null;
    datasetLabel: string;
    // Concurrency token rotated by switchDataset/switchFieldComponent so older
    // in-flight loads can detect they were superseded and bail.
    switchToken?: symbol;
}

export function createFieldState(): FieldState {
    return {
        metadata: null,
        data: {},
        gridFlat: null,
        currentComponent: DATASET_DEFAULTS.component,
        currentDataset: DATASET_DEFAULTS.key,
        hdf5Url: DATASET_DEFAULTS.url,
        modelName: '',
        dataTime: null,
        dataTimeUnits: null,
        datasetLabel: '',
    };
}
